<template>
  <div class="create-sign-up-root sign-up-root">
    <div class="main-content-wrap">
      <yioks-page-nav @backBtnHandle="backComfim=true" class="nav-wrap">
        <p class="title">创建继续教育培训</p>
        <div class="nav-right" slot="right"></div>
      </yioks-page-nav>
      <div class="content-wrap">
        <vue-scroll :ops="vuescrollOpt">
          <div class="form-wrap">
            <el-form
              :model="formData"
              :rules="formRules"
              ref="mainForm"
              label-width="200px"
              size="medium"
              class="form-cont"
            >
              <el-form-item label="继续教育等级" prop="class_level" class>
                <el-select
                  v-model="formData.class_level"
                  disabled
                  class="input-w260"
                  placeholder="请选择继续教育等级"
                >
                  <el-option
                    v-for="item in highClassLevelList"
                    :key="item.value"
                    :label="item.key"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              
              <el-form-item label="继续教育类型" prop="education_type" class>
                <el-select
                  v-model="formData.education_type"
                  disabled
                  class="input-w260"
                  placeholder="请选择继续教育类型"
                >
                  <el-option
                    v-for="item in enroll_type_list"
                    :key="item.value"
                    :label="item.key"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              
              <el-form-item label="继续教育名称" prop="sign_name" class="test-inline">
                <el-button type="primary" @click="ifNameDiaShow=true">添加名称</el-button>
                <span class="text_line right">{{formData.sign_name}}</span>
              </el-form-item>
              
              <el-form-item label="培训日期" prop="trainRange">
                <el-date-picker
                  type="daterange"
                  :editable="false"
                  :clearable="false"
                  :picker-options="trainRangeOpt"
                  value-format="timestamp"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  v-model="formData.trainRange"
                  class="input-w360"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="学时" prop="hours" class>
                <el-select
                  v-model="formData.hours"
                  class="input-w260"
                  filterable
                  allow-create
                  default-first-option
                  placeholder="请选择或者填写学时"
                >
                  <el-option label="16" value="16"></el-option>
                  <el-option label="32" value="32"></el-option>
                  <el-option label="48" value="48"></el-option>
                  <el-option label="60" value="60"></el-option>
                </el-select>
                <span class="cost-text">单位：小时</span>
              </el-form-item>
              <el-form-item label="学习视频模板" prop="video_template" class>
                <el-select
                  v-model="formData.video_template"
                  class="input-w260"
                  filterable
                  allow-create
                  default-first-option
                  placeholder="请选择学习视频模板"
                >
                  <el-option
                    v-for="item in videoTemplateList"
                    :key="item.template_id"
                    :label="item.title"
                    :value="item.template_id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="本次继续教育执照有效期" prop="date_limit">
                <el-date-picker
                  v-model="formData.date_limit"
                  :editable="false"
                  :clearable="false"
                  value-format="yyyy"
                  type="year"
                  class="w100"
                  style="width:120px"
                  placeholder="请选择年份"
                ></el-date-picker>
                <span style="font-size:18px;margin-left:5px">年12月31日</span>
              </el-form-item>
              <el-form-item label="说明" prop="intro" >
                <el-input type="textarea"
                  :autosize="{ minRows: 6}"
                  v-model="formData.intro" class placeholder="请输入200字以内说明"
                  maxlength="200">
                  
                </el-input>
              </el-form-item>
            
            </el-form>
          </div>
        </vue-scroll>
      </div>
      <div class="post-btn">
        <el-button :disabled="submitDisabled" @click="startClass('Edit')">暂时保存</el-button>
        <el-button type="primary" :disabled="submitDisabled" @click="startClass('Next')">下一步（选择学员）</el-button>
      </div>
    </div>
    <el-dialog
      :visible.sync="ifNameDiaShow"
      :close-on-click-modal="false"
      top="13vh"
      width="450px"
      class="yi-dialog-root"
    >
      <div class="slot-dialog-header" slot="title">
        <span class="title">添加继续教育名称</span>
      </div>
      <div class="dialog-content name-dia-content">
        <el-form
          :model="nameData"
          :rules="nameFormRules"
          ref="nameDialogForm"
          label-width="100px"
          size="medium"
          class="dia-form"
        >
          <el-form-item label="开启自定义" prop="ifCustom" class>
            <el-switch v-model="nameData.ifCustom" class=""></el-switch>
          </el-form-item>
          
          <el-form-item v-show="nameData.ifCustom" label="自定义名称" prop="custom" class>
            <el-input v-model.trim="nameData.custom" class="" :disabled='!nameData.ifCustom' placeholder="请填写报名名称" maxlength="50" ></el-input>
          </el-form-item>
          
          <div v-show="!nameData.ifCustom">
            <el-form-item label="年份" prop="year">
              <el-date-picker
                v-model="nameData.year"
                :editable="false"
                :clearable="false"
                :picker-options="yearOpt"
                value-format="yyyy"
                type="year"
                :disabled='nameData.ifCustom'
                class="w100"
                placeholder="请选择年份"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="次数" prop="times" class>
              <span class="text_line left">第</span>
              <el-input-number
                v-model="nameData.times"
                controls-position="right"
                :min="1"
                :step="1"
                step-strictly
                :disabled='nameData.ifCustom'
              ></el-input-number>
              <span class="text_line right">次</span>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="footer-btn" slot="footer">
        <div class="btns">
          <el-button type="primary" @click="saveNameData">保存</el-button>
          <el-button type="danger" @click="ifNameDiaShow=false">取消</el-button>
        </div>
      </div>
    </el-dialog>
    <yioks-tips :showTips="tipsFlag"
      :tips="tipMsg"
      :loading="submitLoading"
      @hideTips="hideTipsDialog"></yioks-tips>
    <yioks-tips :showTips="backComfim" tips="确定放弃修改并返回吗？" @hideTips="backComfimDialog"></yioks-tips>
  </div>
</template>

<script>
  import SignUpMixin from './education-minix';
  import { educationCrateOne,educationInfo,getVideoTemplate } from "@/api/education/education";
  
  export default {
    name: "EducationCrateOne",
    mixins: [SignUpMixin],
    props: ['classLevel','enrollType'],
    created() {
      this.formData.class_level = this.$route.query.classLevel;
      this.formData.education_type="continue_education";
      // 如果是编辑
      if (this.$route.query.edu_id) {
        this.formData.edu_id = this.$route.query.edu_id;
        this.getEducationInfo();
      }else{
        this.getVideoTemplateList(this.formData.class_level);
      }
    },
    data() {
      // 当月最后一天
      // new Date(this.formData.endMonth.getFullYear(), this.formData.endMonth.getMonth()+1,0);
      return {
        tipMsg: '确定提交？',
        submitLoading: false,
      };
    },
    methods: {
      // 获取视频模板
      getVideoTemplateList(level){
        getVideoTemplate({
          level: level,
          education_type: this.formData.education_type,
        })
        .then((res) => {
          if(res.data.status !== 0){
            this.$message.error(res.data.msg);
            return;
          }
          
          const { templateData,date_limit } = res.data.result;
          this.videoTemplateList = templateData;
          console.log(this.formData.date_limit)
          if(!this.formData.date_limit){
            this.formData.date_limit = date_limit;
          }
        })
        .catch((err) => {});
      },
      submit() {
        this.submitLoading = true;
        const formData = JSON.parse(JSON.stringify(this.formData));
        const submitData = {
          edu_id: formData.edu_id,
          name: formData.sign_name,
          level: formData.class_level,
          education_type:formData.education_type,
          start_date: formData.trainRange[0],
          end_date: formData.trainRange[1],
          content: formData.intro,
          hours: formData.hours,
          status: this.ajaxStatus,
          date_limit:formData.date_limit,
          video_template:formData.video_template,
         
        }
        educationCrateOne(submitData).then(({data}) => {
          this.submitLoading = false;
          if(data.status===0) {
            const { education_info } = data.result;
            // 下一步
            if(this.ajaxStatus === 'Next'){
              this.$router.push({
                path:"education_crate_second",
                query: {
                  edu_id: education_info.edu_id,
                  education_type : education_info.education_type,
                },
              });
            } else{
              this.$router.push({
                path:"education_detail",
                query: {
                  edu_id: education_info.edu_id,
                  type:"edit"
                },
              });
//              this.$router.go(-1);
            }
            
          } else {
            this.$message.error(data.msg);
            return;
          }
        }).catch(err => {
          this.submitLoading = false;
          console.log(err);
        });
      },
      getEducationInfo(){
        educationInfo({
          edu_id: this.formData.edu_id,
        })
        .then((res) => {
          if(res.data.status !== 0){
            this.$message.error(res.data.msg);
            return;
          }
          const { nullToStr } = this.$yioks;
          const { educationTrain } = res.data.result;
          this.formData.class_level = educationTrain.level;
          this.formData.sign_name = educationTrain.name;
          this.formData.hours = educationTrain.hours.toString();
          this.formData.edu_id = educationTrain.edu_id;
          this.formData.education_type = educationTrain.education_type;
          this.formData.intro = educationTrain.content;
          this.formData.video_template = educationTrain.video_template;
          this.formData.trainRange = [educationTrain.start_date, educationTrain.end_date];
          this.formData.date_limit = educationTrain.date_limit;
          this.getVideoTemplateList(educationTrain.level);
        })
        .catch((err) => {});
      },
    },
    
  };
</script>

<style lang="stylus">
  @import './education.styl'
  .flex-box
    display: flex
    justify-content: flex-start
    .right
      margin-left 20px
      box-sizing: border-box
</style>
